import { useContext } from 'react';
import DiscoveryContextV2 from '../../../contexts/discoveryContext/contextV2';

// Uses Global Context and properties to determine when to conditionally render the Banner
const BannerWrapper = ({ mapParamInSearchQuery, children }) => {
  const {
    activeFilters: { date, distance, tag } = {},
    filters: { location: { isLocationSetByUser } = {} } = {},
  } = useContext(DiscoveryContextV2);

  // CASE 1: Removes when map page is turned on.
  if (mapParamInSearchQuery) return null;

  // CASE 2: Do not render when  Category Discovery Page Find Mode with Map is active (filter is active)
  if (date || distance || tag || isLocationSetByUser) {
    return null;
  }

  return children;
};

export default BannerWrapper;
